import React, { useContext } from "react";
import { ProfileContext } from "../../../Services/ProfileProvider";
import { ApiConfig } from "../../../Services/ApiServices/AuthAction/ApiConfig";
import { Link, useNavigate } from "react-router-dom";
import { alertSuccessMessage } from "../../../Services/CustomAlertModel";

const Header = () => {
  const { userDetails, setLoginDetails } = useContext(ProfileContext);
  const navigate = useNavigate()

  const tokenExpire = () => {
    sessionStorage.clear();
    navigate("/");
    alertSuccessMessage("You have been logged out successfully");
    setLoginDetails({});
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (

    <div className="c_header" >
      <div className="container" >
        <div className="sec_nav" >
          <a className="sec_logo " >
           <Link to="/dashboard"> <img src="assets/images/logo.svg" width="190" class="navbar-brand  " /></Link>
          </a>
          <div className="nav_right" >
            <div className="us_profile" >
              {/*   <img
                alt=""
                className="avatar"
                src={userDetails?.user_image ? `${ApiConfig?.url + userDetails.user_image}` : "assets/images/user.png"}
                onError={(e) => { e.target.src = "assets/images/user.png"; }}
              /> */}

              <img
                alt=""
                className="avatar"
                src="assets/images/NEWUSER.jpeg"
              />

              <span className="d-none d-xl-block" >{userDetails?.name || "UNKNOWN USER"}</span>
            </div>
            <div class="dropdown custom-dropdown">
              <button class="btn btn-icon btn-primary-light " type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                <i class="ri-settings-5-fill"></i>
              </button>
              <div class="dropdown-menu" data-bs-popper="static">
                <Link class="header__el" to="/user_profile">
                  <i class="ri-user-line"></i>
                  <div class="header__details">
                    <div class="header__title">Account Details</div>
                    <div class="header__content">Important account details</div>
                  </div>
                </Link>
                <Link class="header__el" to="/change_password">
                  <i class="ri-wallet-line"></i>
                  <div class="header__details">
                    <div class="header__title">Change Password</div>
                    <div class="header__content"> Strong Security to change password</div>
                  </div>
                </Link>
                <div class="header__el cursor-pointer" onClick={tokenExpire}>
                  <i class="ri-logout-circle-r-line"></i>
                  <div class="header__details">
                    <div class="header__title">Logout</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  )
}

export default Header


